const data = [
  {
    home_page: {
      title:
        "Discover Skimitar Hindusthan - Learn Through Articles, News, and Upcoming Events",
      meta: {
        meta1: {
          name: "description",
          content:
            "Rolling Energy drives Nigeria's clean energy shift with Compressed Natural Gas (CNG), paving the way for a sustainable, cost-effective future. Install CNG Conversion kits in two wheelers, four wheelers, three wheelers, Heavy Vehicles, and Generators.",
        },
      },
    },

    industrial_automation_page: {
      title:
        "Industrial Automation Courses | PLC, SCADA & Robotics Training – Scimitar Academy",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join Industrial Automation Courses covering PLC, SCADA, Robotics, HMI and Process Control. Beginner to Advanced level training with certification at Scimitar Academy.",
        },
      },
    },
    digitalmarketing_page: {
      title:
        "Digital Marketing Course | SEO, PPC, Social Media Training – Skimitar Academy",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join our Digital Marketing Course covering SEO, PPC, Social Media Marketing, Content Marketing, Email Marketing and Analytics. Beginner to Advanced level training with certification at Skimitar Academy.",
        },
      },
    },

    information_technology_page: {
      title:
        "IT Training Courses | Full Stack, Web, Data Analytics & UI UX – Skimitar Academy",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join our IT Training Courses including Full Stack Development, Web Development, Data Analytics, Mobile App Development and UI/UX Designing. Industry-focused training with hands-on projects and certification at Skimitar Academy.",
        },
      },
    },

    Internship_page: {
      title:
        "Internship Programs | Industrial Automation & Digital Marketing – Skimitar Academy",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join our Internship Programs in Industrial Automation and Digital Marketing. Gain hands-on experience with live projects, industry mentorship, practical training, and certification at Skimitar Academy.",
        },
      },
    },

    workshop_page: {
      title:
        "Workshops | Industrial Automation & Digital Marketing Training – Skimitar Academy",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join our hands-on workshops in Industrial Automation and Digital Marketing. Learn PLC, SCADA, IoT, SEO, Social Media, PPC and Analytics with real-world projects and certification at Skimitar Academy.",
        },
      },
    },

    seminar_page: {
      title:
        "Seminars | Industrial Automation & Digital Marketing Insights – Skimitar Academy",
      meta: {
        meta1: {
          name: "description",
          content:
            "Attend expert-led seminars on Industrial Automation and Digital Marketing. Learn about PLC, SCADA, Industry 4.0, SEO, Social Media, analytics, and emerging trends with practical insights at Skimitar Academy.",
        },
      },
    },

    corporate_training_page: {
      title:
        "Corporate Training Programs | Industrial Automation & Digital Marketing – Skimitar Academy",
      meta: {
        meta1: {
          name: "description",
          content:
            "Customized corporate training programs in Industrial Automation and Digital Marketing. Upskill your workforce with PLC, SCADA, SEO, PPC, Social Media and analytics training at Skimitar Academy.",
        },
      },
    },

    about_page: {
      title:
        "Skimitar Hindusthan: Our Story and Commitment - Stay Updated with News and Events",
      meta: {
        meta1: {
          name: "description",
          content:
            "Learn about Rolling Energy Private Limited, an independent oil and gas company founded in 2020 with a mission to transform +'s energy landscape through Compressed Natural Gas (CNG) and convert vehicles to use CNG",
        },
      },
    },
    digital_marketing_page: {
      title:
        "Scimitar Hindustan – CNG Refuelling Station and  Install CNG Conversion kits in vehicles",
      meta: {
        meta1: {
          name: "description",
          content:
            "Install Rolling Energy CNG Conversion kits in domestic, commercial vehicles, industrial vehicles, and automotive applications in Nigeria",
        },
      },
    },

    service_page: {
      title:
        "Scimitar Hindustan – CNG Refuelling Station and  Install CNG Conversion kits in vehicles",
      meta: {
        meta1: {
          name: "description",
          content:
            "Install Rolling Energy CNG Conversion kits in domestic, commercial vehicles, industrial vehicles, and automotive applications in Nigeria",
        },
      },
    },
    career_page: {
      title:
        "Careers at Skimitar Hindusthan - Discover Opportunities, Insights & Events",
      meta: {
        meta1: {
          name: "description",
          content:
            "Rolling Energy - Learn More through Rolling Energy Article, News, Events",
        },
      },
    },
    contact_page: {
      title:
        " Contact Us at Skimitar Hindusthan - Your Source for News and Insights",
      content:
        "Connect with Rolling Energy for expert CNG conversion services in Nigeria, backed by government support, and drive towards a sustainable, clean energy future.",

      meta: {
        meta1: {
          name: "description",
          content:
            "Connect with Rolling Energy for expert CNG conversion services in Nigeria, backed by government support, and drive towards a sustainable, clean energy future.",
        },
      },
    },
    cookieContent:
      "We use our own cookies for the use of the rolling energy site, personalize content and perform analyses of our traffic. We also share information about your use of our site with analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.",
  },
  {
    news_data: {
      news1: {
        youtube_embed:
          "https://www.youtube.com/embed/1I8TRLX4FSU?si=GV9OO58AQIMUvaQb",
        title: "FG Launches CNG Vehicle Conversion Centre In Kaduna State",
        content:
          "The Federal Government has inaugurated a Presidential Compressed Natural Gas Initiative Conversion Center in Kaduna State.",
        link: "https://www.youtube.com/watch?v=1I8TRLX4FSU",
      },
      news2: {
        youtube_embed:
          "https://www.youtube.com/embed/6los64VTOSU?si=CqAp0vWUWQhEbx25",
        title: "CNG Initiative to Create 50,000 Jobs in 6Month",
        content:
          "Nigeria begins Journey of transition into gas power economy. Presidential initiative to convert 1 million gas-powered cars and 50,000 Jobs.",
        link: "https://www.youtube.com/watch?v=6los64VTOSU",
      },
    },
  },

  {
    articles_page: {
      articles1: {
        img: "https://dailytrust.com/wp-content/uploads/2023/07/CNG.jpg",
        title: "CNG Conversion Centre To Redefine Transportation In Kaduna",
        content:
          "Nigeria is definitely taking a significant step forward with the government’s drive, under the visionary leadership of President Bola Ahmed Tinubu, for transitioning to a more affordable yet efficient alternative energy.",
        link: "https://dailytrust.com/cng-conversion-centre-to-redefine-transportation-in-kaduna/",
      },
      articles2: {
        img: "https://i0.wp.com/blueprint.ng/wp-content/uploads/2023/11/IMG_20231104_150135-scaled.jpg?resize=678%2C381&ssl=1",
        title:
          "Nigeria’s gas deposit can power industries, transport for 97 years – FG",
        content:
          "The Federal Government has unveiled the first Compressed Natural Gas (CNG) Conversion Centre in the North-west, while stating that Nigeria’s huge gas deposit can power the nation’s transportation and industrial sectors for 97 years, at a cheaper rate than petrol.",
        link: "https://blueprint.ng/nigerias-gas-deposit-can-power-industries-transport-for-97-years-fg/",
      },
      articles3: {
        img: "https://cdn.vanguardngr.com/wp-content/uploads/2023/11/image-59.png",
        title:
          "FG unveils CNG conversion centre in Kaduna, targets 1 million vehicles before 2027",
        content:
          "The Federal Government has unveiled the first Compressed Natural Gas (CNG) conversion centre in Kaduna, saying President Bola Ahmed Tinubu has a target of having a million out of about 17million vehicles on Nigeria",
        link: "https://www.vanguardngr.com/2023/11/fg-unveils-cng-conversion-centre-in-kaduna-targets-1-million-vehicles-before-2027/",
      },
    },
  },
];

export default data;
